  // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
    //弹框
import { Modal } from 'bootstrap-vue/es/components';
Vue.use(Modal);

import { Card } from 'bootstrap-vue/es/components';
Vue.use(Card);
import { Scrollspy } from 'bootstrap-vue/es/directives';
Vue.use(Scrollspy);
// 图片
import { Image } from 'bootstrap-vue/es/components';
Vue.use(Image);
// nav
import { Nav } from 'bootstrap-vue/es/components';
Vue.use(Nav);
// 轮播图
import { Carousel } from 'bootstrap-vue/es/components';
Vue.use(Carousel);

import { Popover } from 'bootstrap-vue/es/components';
Vue.use(Popover);

import { FormTextarea } from 'bootstrap-vue/es/components';
Vue.use(FormTextarea);
//按钮
import bButton from 'bootstrap-vue/es/components/button/button';
Vue.component('b-button', bButton);
//页码
import { Pagination } from 'bootstrap-vue/es/components';

Vue.use(Pagination);

import { Table } from 'bootstrap-vue/es/components';

Vue.use(Table);

import { FormCheckbox } from 'bootstrap-vue/es/components';

Vue.use(FormCheckbox);

Vue.use(BootstrapVue)

Vue.config.productionTip = false

import VueI18n from 'vue-i18n';

Vue.use(VueI18n);
/*------引入语音包------*/
const i18n = new VueI18n({
    locale: getCookieI18n('PLAY_LANG', 'CN'),
    messages: {
        'CN': require('./assets/common/lang/cn'),
        'EN': require('./assets/common/lang/en'),
    }
})

import '@/assets/sass/sass-index.scss'
import '@/assets/common/style/style.css'

import store from '@/vuex/store'
import { getCookieI18n } from '@/util/cookie.js'
/* eslint-disable no-new */
/*------挂载全局使用------*/
new Vue({
    el: '#app',
    i18n,
    router,
    store,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js